import React, { Component } from 'react'
import PropTypes from 'prop-types'
import AddNewForm from './AddNewForm'
import Datepick from '../datepick'
import moment from 'moment'
import { showMessage } from '../../actions/messageBox'
// import ReferenceDropdown from './ReferenceDropdown'
import AceEditor from 'react-ace'
import ReactAce from 'react-ace-editor';

class JSONForm extends Component {
    constructor(props) {
        super(props)

        this.handleUndo = this.handleUndo.bind(this)
        this.handleAdd = this.handleAdd.bind(this)
        this.handleDelete = this.handleDelete.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleValidate = this.handleValidate.bind(this)
        this.lowerCaseAllKeys = this.lowerCaseAllKeys.bind(this)
        this.changeCallback = this.changeCallback.bind(this)
        this.handleOnEditorLoad = this.handleOnEditorLoad.bind(this)
        this.handleAceEditorChange = this.handleAceEditorChange.bind(this)
        this.changeEditorCallback = this.changeEditorCallback.bind(this)
        

        this.expandButton = React.createRef()
        this.expandButton1 = []

        this.mainInput = HTMLInputElement
        this.history = []

        let JSONStr = this.props.value
        let JSONStrObj = this.lowerCaseAllKeys(JSON.parse(this.props.value))
        JSONStr = JSON.stringify(JSONStrObj)
        

        this.state = {
            JSONStr: JSONStr,
            JSONStrObj: JSONStrObj,
            arrowObjectKeyArray: [],
            endpointFrom: this.props.endpointFrom,
            expanded:false,
            buttonId: null,
            toFocus: false,
            onAddEditor: false,
            funcString: '',
        }


    }

    handleAceEditorChange(newValue,e) {
        
        this.setState({
            funcString: newValue
        })

    }

    lowerCaseAllKeys(obj) {
        let returnObj = {}
        if (typeof obj === "object") {
            for (let key in obj) {
                let newKey = key.toLowerCase().replace(/ /g, '_')
                if (Array.isArray(obj[key])) {
                    returnObj[newKey] = obj[key].map(el => this.lowerCaseAllKeys(el))
                } else if (obj[key] && typeof obj[key] === "object") {
                    returnObj[newKey] = this.lowerCaseAllKeys(obj[key])
                } else {
                    returnObj[newKey] = obj[key]
                }
            }
        }

        return returnObj
    }

    componentWillReceiveProps(nextProps) {

        // console.dir(nextProps)
        // console.dir(this.props)
        let newProps = JSON.stringify(nextProps)
        let oldProps = JSON.stringify(this.props)
        let propIsEqual = newProps === oldProps
        // console.dir(newProps)
        // console.dir(oldProps)

        if(!propIsEqual){
            let JSONStr = nextProps.value
            let JSONStrObj = this.lowerCaseAllKeys(JSON.parse(nextProps.value))
            JSONStr = JSON.stringify(JSONStrObj)
            {
                this.setState({
                    JSONStr: JSONStr,
                    JSONStrObj: JSONStrObj
                })
            }
        }
    }

    toggleAccordion = toggledArrow => {
        let toggle = toggledArrow.target.getAttribute('class')
        toggledArrow.target.setAttribute('autofocus', 'false')
        if (toggle === 'btn arrow-down') {
            toggledArrow.target.setAttribute('class', 'btn arrow-down active')

        } else {
            toggledArrow.target.setAttribute('class', 'btn arrow-down')

        }
    }

    closeCurrentModal = (e) => {

        let modalParentId = e.target.parentNode.parentNode.parentNode.parentNode.getAttribute('id')
        document.getElementById(modalParentId).style.display = 'none'
        // console.log(document.getElementById(modalParentId).style.display = 'none')
    }

    openModal = (e) => {
        let modalId = e.target.getAttribute('data-target')

        // console.log(modalId)

        document.getElementById(modalId.substr(1)).addEventListener('click', () => {
            let openDiv = document.getElementById(modalId.substr(1))
            if (openDiv !== null) {
                openDiv.style.display = 'block'
            }
        })
    }

    titleCase = (str) => {
        // if(this.props.endpointFrom==="connections"|| this.props.endpointFrom==="providers"|| this.props.endpointFrom==="datasources"){
        //     return str.replace(/_/g, ' ' || '_id', 'id')
        // return str.replace(('_' || '-' || ' _' || '_ ' || '.'), ' ' || '_id', 'id')
        //     .toLowerCase()
        //     .split(' ')
        //     .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
        //     .join(' ')
        //     .replace('Id', 'ID')
        // }else{
            //return str.replace(('_' || '-' || ' _' || '_ ' || '.'), ' ' || '_id', 'id')
            return str.replace( /_/g,' '||('_' || '-' || ' _' || '_ ' || '.'), ' ' || '_id', 'id')
            .toLowerCase()
            .split(' ')
            .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
            .join(' ')
            .replace('Id', 'ID')
        // }
       
        
            
    }
    changeEditorCallback() {
        // since we are setting the main input value programatically, we need to trigger onChange
        // event manually so Formik can save the changed value
        let funcArray = this.state.funcArgs.slice()
        funcArray.push(this.state.funcBody)
        let actualValue = JSON.stringify({ function: funcArray })

        let nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLTextAreaElement.prototype, "value").set
        nativeInputValueSetter.call(this.mainInput, actualValue)

        let ev2 = new Event('input', { bubbles: true })
        this.mainInput.dispatchEvent(ev2)
    }
    changeCallback() {
        // since we are setting the main input value programatically, we need to trigger onChange
        // event manually so Formik can save the changed value
        let newJSONStr = this.state.JSONStr
        let nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set
        nativeInputValueSetter.call(this.mainInput, newJSONStr)

        var ev2 = new Event('input', { bubbles: true })
        this.mainInput.dispatchEvent(ev2)
    }


    handleDelete(e, fObjKey) {
        let newJSONStrObj = this.buildNewState(fObjKey, null, StateOp.DELETE)
        // if there is a meta tag related to the deleted key, delete it as well
        if (newJSONStrObj.hasOwnProperty('meta')) {
            // if the deleted property was an object, we also need to delete all meta properties
            // under the object key, so we match all child meta keys, eg deleting obj1 should also
            // delete obj1.property1 and obj1.property2 if they exist
            for (var key in newJSONStrObj.meta) {
                if (key === fObjKey || key.indexOf(fObjKey + ".") === 0) {
                    delete newJSONStrObj.meta[key]
                }
            }

            // delete the meta obj if it is empty
            if (Object.keys(newJSONStrObj.meta).length === 0) {
                delete newJSONStrObj.meta
            }
        }

        let newJSONStr = JSON.stringify(newJSONStrObj)

   
        this.setState((prevState) => {
            this.history.push(prevState)
            
            return {
                JSONStr: newJSONStr,
                JSONStrObj: newJSONStrObj
            }
        }, this.changeCallback)
    }

    handleValidate(keyToAdd) {
        let validateResult = { error: "" }
        let nameRestriction = /^[a-zA-Z0-9-_ ]+$/

        if (keyToAdd && !nameRestriction.test(keyToAdd)) {
            validateResult.error = "Character not allowed"
        }


        return validateResult
    }

    handleAdd(keyToAdd, type, parentKey, id) {
        keyToAdd = keyToAdd.replace(/ /g, '_').toLowerCase()
        let newKey = parentKey !== "" ? parentKey + "." + keyToAdd : keyToAdd
        let newVal = null

        let grayoutPass = true

        let integOptionsTab = document.getElementById("integrationOptions-tab")

        if (integOptionsTab) {

            if (integOptionsTab.className.includes("active")) {

                grayoutPass = false
            }
        }

        if(
            grayoutPass && (
                keyToAdd.includes("password") ||
                keyToAdd.includes("key") ||
                keyToAdd.includes("token") ||
                keyToAdd.includes("secret")
            )
        ) {

            type = "password"
        }

        if (type === 'string' || type === 'password' || type === 'textArea') {
            newVal = ""
        } else if (type == 'date') {
            newVal = moment().format('MM-DD-YYYY')
        } else if (type === 'object') {
            newVal = {}
        } else if (type === 'array') {
            newVal = [{}]
        } else if (type === 'boolean'){
            newVal = 0
        }

        let newJSONObj = this.buildNewState(newKey, newVal, StateOp.ADD)
        if (type === 'password' || type === 'date' || type === 'boolean' || type === 'textArea' || type === 'editor') {
            if (!newJSONObj.hasOwnProperty('meta')) {
                //if meta does not exist initialize it
                newJSONObj.meta = {}
            }
            // else{
            //     newJSONObj.meta = {}
            // }
           // console.log('META TESTING',[newKey,type,newJSONObj])

            try {

               newJSONObj.meta = JSON.parse(newJSONObj.meta);
            } catch(e) {

               //Do nothing
            }
                 

            newJSONObj.meta[newKey] = {
                type: type
            }
        }

        let newJSONStr = JSON.stringify(newJSONObj)
        this.setState({
            buttonId: id
        })

        // console.log('this.state.buttonId',document.getElementById(id).getAttribute('aria-expanded'))
        //TRIGGER DROPDOWN
        if (parentKey && document.getElementById(id) && document.getElementById(id).getAttribute('aria-expanded') == 'false') {
            if(!this.state.toFocus){
                document.getElementById(id).click()
            }
        }

        this.setState(prevState => {
            this.history.push(prevState)

            return {
                JSONStr: newJSONStr,
                JSONStrObj: newJSONObj
            }
        }, this.changeCallback)

        let content = document.getElementById("add-new-main");

        if (content) {

            let kbButtons = content.getElementsByTagName("button");

            if (kbButtons) {

                for (let i=0; i < kbButtons.length; i++) {

                    kbButtons[i].disabled=false
                }
            }
        }

        return { success: true }
    }

    handleDupArrayElem(parentKey) {
        let newJSONObj = this.buildNewState(parentKey, {}, StateOp.DUP_ARRAY_ELEM)

        let newJSONStr = JSON.stringify(newJSONObj)
        this.setState(prevState => {
            this.history.push(prevState)

            return {
                JSONStr: newJSONStr,
                JSONStrObj: newJSONObj
            }
        }, this.changeCallback)
    }

    handleOnEditorLoad(editor) {
        let firstBrace = this.state.funcString.indexOf('{') + 1
        let lastBrace = this.state.funcString.lastIndexOf('}') + 1
        let posInEditor = editor.session.doc.indexToPosition(lastBrace)
        
        this.setState({ editor })
    }

    handleChange(e, fObjKey, changeCallback, inputType) {
        let targetVal

        if(inputType && inputType === "checkbox"){
            targetVal = e.target.checked === true ? 1 : 0
        }
        else{
            targetVal = e.target.value[e.target.value.length - 1] === '.' ? e.target.value : Number(e.target.value) || e.target.value
        }
        
        let prepObj = this.buildNewState(fObjKey, targetVal, StateOp.CHANGE_VAL)
        let newJSONStr = JSON.stringify(prepObj)

        this.setState((prevState) => {
            this.history.push(prevState)

            return {
                JSONStr: newJSONStr,
                JSONStrObj: prepObj
            }
        }, () => {
            if (typeof changeCallback === 'function') {
                changeCallback()

            }
        })


    }

    buildNewState(fObjKey, val, operation, oldstate = JSON.parse(this.state.JSONStr),type) {
        const path = fObjKey.split('.')
        const depth = path.length;

        const newstate = Object.assign({}, oldstate)
        let newStateLevel = newstate
        let oldStateLevel = oldstate
        for (let i = 0; i < depth; i += 1) {
            if (i === depth - 1) {
                if (operation === StateOp.CHANGE_VAL) {
                    newStateLevel[path[i]] = val;
                } else if (operation === StateOp.DELETE) {
                    if (Array.isArray(newStateLevel)) {
                        newStateLevel.splice(path[i], 1)
                    } else {
                        if (newStateLevel.hasOwnProperty(path[i])) {
                            delete newStateLevel[path[i]]
                        }
                    }
                } else if (operation === StateOp.ADD) {
                    if (newStateLevel.hasOwnProperty(path[i])) {
                        // do nothing, since key already exists
                    } else {
                        newStateLevel[path[i]] = val;
                    }
                } else if (operation === StateOp.DUP_ARRAY_ELEM) {
                    if (Array.isArray(newStateLevel[path[i]])) {
                        let newElem = { ...newStateLevel[path[i]][0] }
                        newStateLevel[path[i]].push(newElem)
                    }
                } else {
                    // do nothingf

                }
            } else {
                newStateLevel[path[i]] = Array.isArray(oldStateLevel[path[i]]) ? oldStateLevel[path[i]].slice(0) : { ...oldStateLevel[path[i]] };
                oldStateLevel = oldStateLevel[path[i]];
                newStateLevel = newStateLevel[path[i]];

                // We need to also add or delete the new key to all other elements in the array
                if (Array.isArray(newStateLevel) && (operation === StateOp.ADD || operation === StateOp.DELETE)) {
                    for (var j = newStateLevel.length; j--;) {
                        let remainingPath = path.slice(i + 2).join(".")

                        // Add or delete the new key to all other objects in the array
                        if (Number(path[i + 1]) !== j) {
                            let newObj = this.buildNewState(remainingPath, val, operation, newStateLevel[j])
                            newStateLevel.splice(j, 1, newObj)
                        }
                    }
                }
            }
        }

        return newstate
    }

    handleUndo() {
        if (this.history.length) {
            let restoredState = this.history.pop()

            this.setState({ ...restoredState }, this.changeCallback)
        }
    }

    buildForm(parentKey, formObject,fObj) {
        // only do this function for objects
        if (typeof formObject !== 'object') {
            return
        }
        let domObj = []

        for (var fObjKey in formObject) {
            let fObjKeyType = typeof formObject[fObjKey]

            // if key==meta, do not show it
            if (fObjKey === 'meta') {
                continue
            }

            let finalChildKeyName = parentKey ? parentKey + "." + fObjKey : fObjKey

            if (finalChildKeyName == 'retry_error.force_extract') {

                if(this.props.allowedTypes[0] == 'UserAdmin') {

                    continue;
                }
            }

            if (Array.isArray(this.props.hiddenFields) && this.props.hiddenFields.length && this.props.hiddenFields.includes(finalChildKeyName)) {
                continue
            }
           // console.log('formObject[fObjKey]',fObjKeyType)
            if (fObjKeyType === 'string' || fObjKeyType === 'number' || formObject[fObjKey] === null) {

                // Remove support for automatic assumption that _id fields are references
                // This must be part of the field creation / adding process to specify the field
                // as a reference

                //let selectDom
                // if( fObjKey.includes('_id') ){
                //     let keyArr = fObjKey.split('_id')
                //     let endpointName = keyArr[0].match(/y$/) ? 
                //         fObjKey.replace('y_id','ies') :
                //         fObjKey.replace('_id','s')
                //     endpointName = endpointName.toLowerCase()

                //     selectDom = <ReferenceDropdown 
                //                     id={finalChildKeyName}
                //                     key={finalChildKeyName} 
                //                     endpointName={endpointName} 
                //                     value={formObject[fObjKey]} 
                //                     onChange={e => {this.handleChange(e, finalChildKeyName)}}
                //                     onBlur={this.changeCallback} />
                // }

                let passwordField = false
                let dateField = false
                let booleanField = false
                let inputType = ""

                let getEndpointFrom = this.state.endpointFrom
                let isUserAdmin = this.props.isUserAdmin
                let endpointFrom = this.props.endpointFrom

                if (this.state.JSONStrObj.hasOwnProperty('meta') &&
                    this.state.JSONStrObj.meta.hasOwnProperty(finalChildKeyName) &&
                    this.state.JSONStrObj.meta[finalChildKeyName].hasOwnProperty('type')) {
                        
                    if (this.state.JSONStrObj.meta[finalChildKeyName].type === 'password') {
                        // field is a password
                        passwordField = true
                        inputType = "password"
                    } else if (this.state.JSONStrObj.meta[finalChildKeyName].type === 'date') {
                        dateField = true 
                    } else if (this.state.JSONStrObj.meta[finalChildKeyName].type === 'boolean'){
                        booleanField = true
                        inputType="checkbox"
                    } else if (this.state.JSONStrObj.meta[finalChildKeyName].type === 'textArea'){
                        inputType="textArea"
                    } else if (this.state.JSONStrObj.meta[finalChildKeyName].type === 'editor'){
                        inputType="editor"
                    }
                     else{
                        inputType="text"
                    }
                }
                if (inputType === "editor") {
                    domObj.push(
                        <div key={finalChildKeyName} className="row mt-2">
    
                            <div className= {fObj ? `col-2 text-left ${fObj}` : `col-2 text-left ${this.props.name}`}>
                                <label htmlFor={finalChildKeyName} >
                                    <span className="text-left">{this.titleCase(fObjKey)}</span>
                                </label>
                            </div>
                            <div className={fObj ? `col-8 ${fObj}` : `col-9 ${this.props.name}` }>
                                <AceEditor 
                                    mode="html"
                                    theme="monokai"
                                    width="100%"
                                    height="100%"
                                    style={{ minHeight: 300 }}
                                    fontSize={14}
                                    showPrintMargin={false}
                                    showGutter={true}
                                    highlightActiveLine={false}
                                    id={finalChildKeyName}
                                    value= {formObject[finalChildKeyName]? formObject[finalChildKeyName] : ''}
                                    onLoad={this.handleOnEditorLoad}
                                    onChange={ e => 
                                    {

                                        let prepObj = this.buildNewState(fObjKey, e, StateOp.CHANGE_VAL)
                                        let newJSONStr = JSON.stringify(prepObj)
                                        this.setState((prevState) => {

                                            let prev = { ...prevState.JSONStrObj }
                                           // console.log('PREVVVVV', prev)
                                            prev[finalChildKeyName] = e 

                                            return {
                                                JSONStrObj: prev,
                                                JSONStr: JSON.stringify(prev)
                                            }                                      

                                        })
                                        this.props.onChange(e)
                                    } }
                                    onBlur={this.changeCallback}
                                />
                            </div>
                            <div className={fObj ? `col-1 text-right ${fObj}`:`col-1 text-right ${this.props.name} `}>
                               {endpointFrom === "connections" ? !isUserAdmin ? "":
                               <button type="button"
                                            title="deletes"
                                            className="btn btn-danger btn-sm align-self-end"                                         
                                            onClick={e =>this.props.dispatch(showMessage({
                                                type: "info",
                                                title: "Confirmation",
                                                message: " Are you sure want to delete this?",
                                                timeout: 0,
                                                buttonArray: ["Yes", "No"],
                                                onClick: (buttonIndex) =>{
                                                        if(buttonIndex === 0){                               
                                                            this.handleDelete(e, finalChildKeyName)
                                                        } 
                                                    }
                                                }))
                                            } 
                                            >
                                    <i className="fa fa-trash"></i>
                                </button>
                                : 
                                (this.props.allowedTypes[0] != 'UserAdmin' && <button type="button"
                                            title="delete"
                                            className="btn btn-danger btn-sm align-self-end"                                         
                                            onClick={e =>this.props.dispatch(showMessage({
                                                type: "info",
                                                title: "Confirmation",
                                                message: " Are you sure want to delete this?",
                                                timeout: 0,
                                                buttonArray: ["Yes", "No"],
                                                onClick: (buttonIndex) =>{
                                                        if(buttonIndex === 0){                               
                                                            this.handleDelete(e, finalChildKeyName)
                                                        } 
                                                    }
                                                }))
                                            } 
                                            >
                                    <i className="fa fa-trash"></i>
                                </button>)
                            }
                            </div>
                        </div>
                        
                    )
                }
                else if (inputType === "textArea") {
                    domObj.push(
                        <div key={finalChildKeyName} className="row mt-2">
    
                            <div className= {fObj ? `col-2 text-left ${fObj}` : `col-2 text-left ${this.props.name}`}>
                                <label htmlFor={finalChildKeyName} >
                                    <span className="text-left">{this.titleCase(fObjKey)}</span>
                                </label>
                            </div>
                            <div className={fObj ? `col-8 ${fObj}` : `col-9 ${this.props.name}` }>
                                <textarea  
                                    rows="12"
                                    type={inputType}
                                    id={finalChildKeyName}
                                    className="form-control"
                                    onChange={e => { this.handleChange(e, finalChildKeyName,this.changeCallback,inputType) }}
                                    onBlur={this.changeCallback} >
                                       {formObject[fObjKey]}
                                </textarea>
                            </div>
                            <div className={fObj ? `col-1 text-right ${fObj}`:`col-1 text-right ${this.props.name} `}>
                               {endpointFrom === "connections" ? !isUserAdmin ? "":
                               <button type="button"
                                            title="deletes"
                                            className="btn btn-danger btn-sm align-self-end"                                         
                                            onClick={e =>this.props.dispatch(showMessage({
                                                type: "info",
                                                title: "Confirmation",
                                                message: " Are you sure want to delete this?",
                                                timeout: 0,
                                                buttonArray: ["Yes", "No"],
                                                onClick: (buttonIndex) =>{
                                                        if(buttonIndex === 0){                               
                                                            this.handleDelete(e, finalChildKeyName)
                                                        } 
                                                    }
                                                }))
                                            } 
                                            >
                                    <i className="fa fa-trash"></i>
                                </button>
                                : 
                                (this.props.allowedTypes[0] != 'UserAdmin' && <button type="button"
                                            title="delete"
                                            className="btn btn-danger btn-sm align-self-end"                                         
                                            onClick={e =>this.props.dispatch(showMessage({
                                                type: "info",
                                                title: "Confirmation",
                                                message: " Are you sure want to delete this?",
                                                timeout: 0,
                                                buttonArray: ["Yes", "No"],
                                                onClick: (buttonIndex) =>{
                                                        if(buttonIndex === 0){                               
                                                            this.handleDelete(e, finalChildKeyName)
                                                        } 
                                                    }
                                                }))
                                            } 
                                            >
                                    <i className="fa fa-trash"></i>
                                </button>)
                            }
                            </div>                            
                        </div>
                    )

                } else {
                    domObj.push(
                        <div key={finalChildKeyName} className="row mt-2">
    
                            <div className= {fObj ? `col-2 text-left ${fObj}` : `col-2 text-left ${this.props.name}`}>
                                <label htmlFor={finalChildKeyName} >
                                    <span className="text-left">{this.titleCase(fObjKey)}</span>
                                </label>
                            </div>
                            <div className={fObj ? `col-8 ${fObj}` : `col-9 ${this.props.name}` }>
                                {dateField ? 
                                    getEndpointFrom ?
                                        <Datepick
                                            id={finalChildKeyName}
                                            className={"form-control"}
                                            selected={Date.parse(formObject[fObjKey] && formObject[fObjKey].split(" ")[0]) || ""}
                                            onChange={e => { this.handleChange(e, finalChildKeyName, this.changeCallback) }}
                                            endpointFrom={getEndpointFrom}
                                        />
                                        :
                                        <Datepick
                                            id={finalChildKeyName}
                                            className={"form-control"}
                                            selected={Date.parse(formObject[fObjKey] && formObject[fObjKey].split(" ")[0]) || ""}
                                            onChange={e => { this.handleChange(e, finalChildKeyName, this.changeCallback) }}
                                        />
    
                                    : booleanField?
                                    <input
                                        // type={passwordField ? "password" : booleanField"text"}
                                        type={inputType}
                                        id={finalChildKeyName}
                                        // className="form-control"
                                        className={`form-control ${inputType}`}
                                        checked={formObject[fObjKey] ? true:false}
                                        onChange={e => { this.handleChange(e, finalChildKeyName,this.changeCallback,inputType) }}
                                        onBlur={this.changeCallback} 
                                    />
                                    :
                                    <input
                                        // type={passwordField ? "password" : booleanField"text"}
                                        type={inputType}
                                        id={finalChildKeyName}
                                        // className="form-control"
                                        className={`form-control ${inputType}`}
                                        value={formObject[fObjKey] || ""}
                                        onChange={e => { this.handleChange(e, finalChildKeyName,this.changeCallback,inputType) }}
                                        onBlur={this.changeCallback} 
                                    />
                                }  
                              
                            </div>
                            <div className={fObj ? `col-1 text-right ${fObj}`:`col-1 text-right ${this.props.name} `}>
                               {endpointFrom === "connections" ? !isUserAdmin ? "":
                               <button type="button"
                                            title="deletes"
                                            className="btn btn-danger btn-sm align-self-end"
                                            // onClick={e => this.handleDelete(e, finalChildKeyName)} 
                                            // onClick={e => {
                                            //     const confirmed = window.confirm('Are you sure?');
                                            //     if(confirmed){
                                            //         this.handleDelete(e, finalChildKeyName);
                                            //     }
                                            // }}
                                            onClick={e =>this.props.dispatch(showMessage({
                                                type: "info",
                                                title: "Confirmation",
                                                message: " Are you sure want to delete this?",
                                                timeout: 0,
                                                buttonArray: ["Yes", "No"],
                                                onClick: (buttonIndex) =>{
                                                        if(buttonIndex === 0){                               
                                                            this.handleDelete(e, finalChildKeyName)
                                                        } 
                                                    }
                                                }))
                                            } 
                                            >
                                    <i className="fa fa-trash"></i>
                                </button>
                                : 
                                (this.props.allowedTypes[0] != 'UserAdmin' && <button type="button"
                                            title="delete"
                                            className="btn btn-danger btn-sm align-self-end"
                                            // onClick={e => this.handleDelete(e, finalChildKeyName)} 
                                            // onClick={e => {
                                            //     const confirmed = window.confirm('Are you sure?');
                                            //     if(confirmed){
                                            //         this.handleDelete(e, finalChildKeyName);
                                            //     }
                                            // }}
                                            onClick={e =>this.props.dispatch(showMessage({
                                                type: "info",
                                                title: "Confirmation",
                                                message: " Are you sure want to delete this?",
                                                timeout: 0,
                                                buttonArray: ["Yes", "No"],
                                                onClick: (buttonIndex) =>{
                                                        if(buttonIndex === 0){                               
                                                            this.handleDelete(e, finalChildKeyName)
                                                        } 
                                                    }
                                                }))
                                            } 
                                            >
                                    <i className="fa fa-trash"></i>
                                </button>)
                            }
                            </div>
                            
                        </div>
                    )
                }
                
            }
            else if (fObjKeyType === 'object') {

               // console.log('this.state.JSONStrObj.meta[finalChildKeyName].type',this.state.JSONStrObj.meta[finalChildKeyName])
                let fieldIsObject = fObjKeyType
                let childObjFields = this.buildForm(finalChildKeyName, formObject[fObjKey],fieldIsObject)

                // Assign unique Id's for nested arrays and objects with the same parent index value
                let arrowObjectKeyCount = Math.floor(Math.random() * 10001)
                let arrowObjectKeyChecker = `toggle${fObjKey}` + arrowObjectKeyCount
                let allowedTypes = this.props.allowedTypes


                        
                let jsonObjectTypes = this.props.allowedTypes
                jsonObjectTypes = jsonObjectTypes.filter(arr => arr != "Object")

                // domObj.push(



                //     <div key={finalChildKeyName} className="row mt-2 px-0">

                //         <div className="col-12 row px-0 mx-0">

                //             <div className="col-2">
                //                 {/* <span className="string-label align-middle">
                //                     {
                //                         // this.titleCase(`${(isNaN(fObjKey)) ? this.titleCase(` ${fObjKey} `) : this.titleCase(`Index ${fObjKey}`)}`)
                //                     }

                //                     {
                //                         // Array.isArray(fObjKey) ? <span className="">{this.titleCase(parentKey)} </span> : <span className=""></span>
                //                     }
                //                 </span> */}
                //                 {/* <label htmlFor={finalChildKeyName} >
                //                     <span className="text-left">{this.titleCase(fObjKey)}</span>
                //                 </label> */}
                //             </div>
                //             <div className="col-9 ">
                                
                //             <i className="fa fa-caret-right fa-fw"></i>
                //                 <div className="card">
                //                     <div className="card-header modal-header mx-0 px-1">

                //                         <div className="row">

                //                             <div className="float-left">
                //                                 <div className="btn-group" id="toggle_button">
                //                                     {
                //                                         (Array.isArray(formObject[fObjKey])) ?

                //                                             <div className="btn" ref={`${this}.#toggle${fObjKey}`} data-toggle="modal" data-target={'#' + arrowObjectKeyChecker} title="Pop-up Data" aria-expanded="false" aria-controls="collapseExample">{'Array'}</div>


                //                                             :


                //                                             <div className="btn" ref={`${this}.#toggle${fObjKey}`} data-toggle="modal" data-target={'#' + arrowObjectKeyChecker} title="Toggle Data" aria-expanded="false" aria-controls="collapseExample">{fObjKey.charAt(0).toUpperCase() + fObjKey.slice(1)}</div>


                //                                     }


                //                                 </div>
                //                             </div>

                //                         </div>
                //                     </div>
                //                 </div>
                //             </div>

                //             <div className="col-1 mt-1">
                //                 <div className="btn-group float-right" role="group" aria-label="object functions">

                //                     <button type="button" className="btn btn-danger btn-sm"
                //                         title="delete"
                //                         disabled={Array.isArray(formObject) && Number(fObjKey) === 0}
                //                         onClick={e => this.handleDelete(e, finalChildKeyName)} >
                //                         <i className="fa fa-trash"></i>
                //                     </button>

                //                 </div>
                //             </div>
                //         </div>

                //         <div className="card-body modal fade" id={arrowObjectKeyChecker} >
                //             <div className="modal-dialog modal-lg" role="document">
                //                 <div className="modal-content">
                //                     <div className="modal-header">
                //                         <span className="string-label align-middle modal-title">{this.titleCase(`${(isNaN(fObjKey)) ? this.titleCase(` ${fObjKey} `) : this.titleCase(`Index ${fObjKey}`)}`)}
                //                             {Array.isArray(fObjKey) ?
                //                                 <span className="modal-title">{this.titleCase(parentKey)} </span> : <span className=""></span>
                //                             }
                //                         </span>
                //                         <div className="float-right">
                //                             <div className="btn-group" role="group" aria-label="object functions">
                //                                 <AddNewForm
                //                                     id={"add-new-" + finalChildKeyName}
                //                                     type={Array.isArray(formObject[fObjKey]) ? "array" : "object"}
                //                                     parentType={Array.isArray(formObject) ? "array" : "object"}
                //                                     parentKey={finalChildKeyName}
                //                                     allowedTypes={allowedTypes}
                //                                     validation={this.handleValidate}
                //                                     onAdd={this.handleAdd} />
                //                                 {Array.isArray(formObject) &&
                //                                     <button type="button" className="btn btn-info btn-sm"
                //                                         onClick={e => this.handleDupArrayElem(parentKey)} >
                //                                         <i className="fa fa-clone"></i>
                //                                     </button>
                //                                 }
                //                             </div>
                //                         </div>
                //                     </div>

                //                     <div className="modal-body">
                //                         {childObjFields}
                //                     </div>

                //                     <div className="modal-footer">
                //                         <button type="button" className="btn" data-dismiss="" onClick={this.closeCurrentModal}>Close</button>

                //                         <button type="button" className="btn" data-dismiss="modal">Close All</button>
                //                     </div>

                //                 </div>
                //             </div>
                //         </div>
                //     </div> /* End of containing DIV */
                //)

                domObj.push(
                    <div key={finalChildKeyName} className="row mt-2">

                        <div className={`col-2 text-left ${this.props.name}`}>
                            <label htmlFor={finalChildKeyName} >
                                <span className="text-left">{this.titleCase(fObjKey)}</span>
                            </label>
                        </div>
              

               
                        <div className={`col-9 ${this.props.name}`}>
                        
                            <div className="card object" >
                             {/* <button className="row-expand-btn" type="button" data-toggle="collapse" aria-controls={`child-section-${finalChildKeyName}`} data-target={`#child-section-${finalChildKeyName}`} aria-expanded="false" >
                                    { <i className="fa fa-caret-right"></i> }{this.titleCase(fObjKey) + "Object"}
                                </button> */}
                                
                            <div className="object-headers">
                                <button type="button" id={`${finalChildKeyName}`} className={`row-expand-btn jsonform ${finalChildKeyName}`}  data-toggle="collapse" data-bs-toggle="collapse" aria-controls={`child-section-${finalChildKeyName}`} data-target={`#child-section-${finalChildKeyName}`} data-bs-target={`#child-section-${finalChildKeyName}`} aria-expanded="false" >
                                    <i className="fa fa-caret-right"></i>
                                </button>
     
                            </div>
                      
                                <div className="card-object" data-toggle="collapse" data-bs-toggle="collapse" aria-controls={`child-section-${finalChildKeyName}`} data-target={`#child-section-${finalChildKeyName}`} data-bs-target={`#child-section-${finalChildKeyName}`} aria-expanded="false"></div>
                     

                                    <div className="collapse" id={`child-section-${finalChildKeyName}`}>
                                        <div class="card card-body">
                                        {childObjFields}
                                        </div>
                                    </div>
                                </div>
                   
                        </div>
                        <div className={`col-1 text-right ${this.props.name}`}>
                                <AddNewForm
                                    // id={"add-new-jsonform-" + finalChildKeyName  }
                                    id={"add-new-jsonform"}
                                    type={Array.isArray(formObject[fObjKey]) ? "array" : "object"}
                                    parentType={Array.isArray(formObject) ? "array" : "object"}
                                    parentKey={finalChildKeyName}
                                    allowedTypes={jsonObjectTypes}
                                    validation={this.handleValidate}
                                    onAdd={this.handleAdd}
                                    buttonId = {finalChildKeyName}
                                />

                                {this.props.allowedTypes[0] != 'UserAdmin' &&

                                    <button type="button"
                                        title="delete"
                                        className="btn btn-danger btn-sm align-self-end"
                                        // onClick={e => this.handleDelete(e, finalChildKeyName)} 
                                        // onClick={e => {
                                        //     const confirmed = window.confirm('Are you sure?');
                                        //     if(confirmed){
                                        //         this.handleDelete(e, finalChildKeyName);
                                        //     }
                                        // }}
                                        onClick={e =>this.props.dispatch(showMessage({
                                            type: "info",
                                            title: "Confirmation",
                                            message: " Are you sure want to delete this?",
                                            timeout: 0,
                                            buttonArray: ["Yes", "No"],
                                            onClick: (buttonIndex) =>{
                                                    if(buttonIndex === 0){                               
                                                        this.handleDelete(e, finalChildKeyName)
                                                    } 
                                                }
                                            }))
                                        } 
                                        >
                                    <i className="fa fa-trash"></i>
                                    </button>
                                }
                            

                        </div>
                    </div>
                )
            }
            else {
                break
            }
        }

        return domObj
    }

    render() {
        let fields = this.buildForm("", this.state.JSONStrObj)

        let fields2 = []

       if(this.props.allowedTypes[0] == 'UserAdmin') {

            fields.map(item => {

                    if ([
                        "create_filters", "update_filters",
                        "limit", "enable_responder", "response_count",
                        "on_error_continue", "on_update_extract",
                        "retry_error"
                    ].indexOf(item.key) != -1) {

                        

                        fields2.push(item)
                    }
            })
        }

        let initialVal = this.props.value
        //let n = this.props.name
        let formTitle = "Properties"//this.props.label + ' ' + n.charAt(0).toUpperCase()+n.substr(1) +" Properties"
        let allowedTypes = this.props.allowedTypes
        let isUserAdmin = this.props.isUserAdmin
        let endpointFrom = this.props.endpointFrom

        //console.log('initialValinitialVal',initialVal)

        let visibility = "visible"

        if (this.props.hideForm) {

            visibility = "hidden"
        }

        return (
            <div className="JSONForm" id={"JSONForm_" + this.props.id} style={{visibility: visibility}}>
                <input
                    type="text"
                    ref={inp => { this.mainInput = inp }}
                    name={this.props.name}
                    id={this.props.id}
                    onChange={e => { 
                        this.setState({ JSONStr: e.target.value })
                        this.props.onChange(e)
                    }}
                    value={initialVal}
                    className="form-control d-none"
                />

                <div className="card h-100" id="card-property-block">
                    <div className="card-body h-100">
                        <div className="mb-4">
                            <h4 className="JSON-title">{formTitle}
                                <div className="btn-group float-right" role="group" aria-label="object functions">
                                    { endpointFrom === "connections" ? !isUserAdmin ? "":
                                        <AddNewForm id="add-new-main" 
                                            type="object" 
                                            parentType="object" 
                                            parentKey="" 
                                            onAdd={this.handleAdd} 
                                            allowedTypes={allowedTypes} 
                                            validation={this.handleValidate} 
                                            dispatch = {this.props.dispatch}
                                            formName={this.props.name}
                                        />
                                        :<AddNewForm id="add-new-main" 
                                        type="object" 
                                        parentType="object" 
                                        parentKey="" 
                                        onAdd={this.handleAdd} 
                                        allowedTypes={allowedTypes} 
                                        validation={this.handleValidate} 
                                        dispatch = {this.props.dispatch}
                                        formName={this.props.name}
                                    />
                }
                                    <button type="button"
                                        className="btn btn-warning btn-sm align-self-end"
                                        onClick={this.handleUndo}
                                        disabled={this.history.length ? false : true}>
                                        <i className="fa fa-undo"></i>
                                    </button>
                                </div>
                            </h4>

                        </div>

                        {this.props.allowedTypes[0] == 'UserAdmin' ? fields2 : fields}
                        
                    </div>
                </div>
            </div>
        )
    }
}

const StateOp = {
    ADD: 'ADD',
    DELETE: 'DELETE',
    CHANGE_VAL: 'CHANGE_VAL',
    CHANGE_KEY: 'CHANGE_KEY',
    DUP_ARRAY_ELEM: 'DUP_ARRAY_ELEM'
}

JSONForm.propTypes = {
    name: PropTypes.string,
    id: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    allowedTypes: PropTypes.array,
    hiddenFields: PropTypes.array
}


export default JSONForm


// WEBPACK FOOTER //
// ./src/components/utilities/JSONForm.js